import { LanguageToggle } from '../LanguageToggle/LanguageToggle';
import { Help } from './Help/Help';
import { Powered } from './Powered/Powered';
import './Footer.scss';

export const Footer = () => {
  return (
    <footer className="Checkout-Footer">
      <div>
        <LanguageToggle />
        <Help />
      </div>
      <div>
        <Powered />
      </div>
    </footer>
  );
};
